module.exports = __webpack_public_path__ + "img/bitcoin.cf8072a1.svg";